var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"options-link"},[_c('div',{staticClass:"link",on:{"click":function($event){return _vm.goRouter()}}},[_c('img',{attrs:{"src":require("../assets/images/config/icon-option.png")}}),_vm._v(" "+_vm._s(_vm.text)+" ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }